import { IEventSelectFieldModel } from "../models/eventSelectFieldModel";

/** Two class names are the same class when they match ignoring case and outer spaces. */
export const isSameClassName = (first?: string | null, second?: string | null) =>
  (first ?? "").trim().toLowerCase() === (second ?? "").trim().toLowerCase();

/**
 * The future classes the sign-up page offers for the chosen option:
 *   1 = same name (a series, its duplicates and single classes alike),
 *   2 = same name and start hour,
 *   3 = every future class.
 * Without the current class's data every class is offered, as before it loads.
 */
export const filterRelatedEvents = (
  events: IEventSelectFieldModel[],
  filterOption: number,
  currentEventName?: string | null,
  currentEventHour?: number | null,
) => {
  switch (filterOption) {
    case 1:
      if (currentEventName == null) return events;
      return events.filter((e) => isSameClassName(e.eventName, currentEventName));
    case 2:
      if (currentEventName == null || currentEventHour == null) return events;
      return events.filter(
        (e) =>
          isSameClassName(e.eventName, currentEventName) &&
          e.startHour === currentEventHour,
      );
    case 3:
    default:
      return events;
  }
};
